import { DecorationModel } from "../_model/DecorationModel";
import { ControllerProductionChangeEditable } from "../productionChangeEditable/controllerProductionChangeEditable"
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { COLORS } from "../../utils/colors"
import * as d3 from "d3"

export class DecorationProductionChangeEditable extends DecorationModel {
  constructor() {
    super("DecorationProductionChangeEditable")
    this.moving = false;
    this.node = null;
    this.ctr = new ControllerProductionChangeEditable();
  
    this.init = async function (newNode, openDialog) {
      let svg = SingletonFlowchart.svg
      this.node = newNode
      this.openDialog = !newNode.readOnly ? openDialog : () => {}

      await svg
        .data([newNode])
        .append("g")
          .attr("id", `${newNode.idName}`)
            
      let g = d3.select(`#${newNode.idName}`);

        // Texto de Descrição
      g.append("text")
        .classed("btProductionChange", true)
        .text(newNode.title)
        .attr("x",  d => d.xTextDescription())
        .attr("y", d => d.yTextDescription())
        .attr("font-size", d => d.fontSize)
        .style("font-weight", 600)
        .style("color", COLORS.Black95)

      newNode.buttons.forEach((b, i) => this.createButtons(g, b, i))
      g.on("dblclick", () => this.openDialog(newNode))
      g.call(this.setDrag())

      return svg
    }

    this.createButtons = function(g, bt, step){
      let that = this

      // Caixa
      g.append("rect")
        .classed(`bt-${step}`, true)
        .classed(`bt-selection`, true)
        .classed("selectable", true)
        .attr("x",  d => d.xBox())
        .attr("y", d => d.yBox(step + 1))
        .style("width", d => d.widthBox())
        .style("height", d => d.heightBox())
        .style("cursor", "pointer")
        .style("fill", d => (d.buttonSelected() == step ? COLORS.OrangePentagro1 : COLORS.OrangePentagro3))
        .on("click", () => that.alterSelect(that.node, step))

      // Texto
      g.append("text")
        .text(bt.caption)
        .classed(`bt-selection`, true)
        .classed(`bt-${step}`, true)
        .classed("selectable", true)
        .style("cursor", "pointer")
        .attr("x",  d => d.xText())
        .attr("y", d => d.yText(step + 1))
        .attr("font-size", d => d.fontSize)
        .style("font-weight", 500)
        .style("color", COLORS.Black95)
        .on("click", () => that.alterSelect(that.node, step))

      return
    }
  
    this.setDrag = function() {
      if(this.node.readOnly)
        return d3.drag();

      let that = this
      let drag = d3
        .drag()
        .on("start", that.dragstarted)
        .on("drag", (event, d) => that.dragged(event, d, that))
        .on("end", (event, d) => that.dragended(d, that));
      return drag;
    }

    this.dragstarted = function(event, d) {
      SingletonFlowchart.selectNode(`${d.idName}`)
    }

    this.dragged = async function (event, d, that){
      d.x = event.x;
      d.y = event.y;
      
      if (!that.moving){
        that.moving = true;

        d3.select(`#${d.idName}`)
          .style("cursor", "grabbing")
          .style("stroke", "black")
      }

      that.move();
    } 

    this.move = async () => {
      let d = this.node

      d3.select(`#${d.idName} > text.btProductionChange`)
        .raise()
        .attr("x", d.xTextDescription())
        .attr("y", d.yTextDescription())

      d.buttons.forEach((b, i) => {
        d3.select(`#${d.idName} > rect.bt-${i}`)
          .raise()
          .attr("x", d.xBox())
          .attr("y", d.yBox(i + 1))

        d3.select(`#${d.idName} > text.bt-${i}`)
          .raise()
          .attr("x", d.xText())
          .attr("y", d.yText(i + 1))
      })
    }

    this.dragended = function(d, that) {
      d3.select(`#${d.idName}`)
        .style("stroke", 'none')
        .style("cursor", "grab")

      that.moving = false;
    };

    this.alterSelect = async function (d, index){
      d.indexSelect(index)
      d.buttons.forEach((b, i) => {
        d3.select(`#${d.idName} > rect.bt-${i}`)
          .style("fill", index == i ? COLORS.OrangePentagro1 : COLORS.OrangePentagro3)
      })

    }

    this.disappearThisNode = function (n){
      let node = SingletonFlowchart.Memory.memory.find(n2 => {
        if(n2.data){
          let attr = n2.data.find(attr => {
            if(attr.index == n.data[0].index && attr.key == n.data[0].key)
              return true
            return false
          })
          if(attr)
            return true
        }
          
        return false
      })
      if(node) {
        node.kill()
        return node
      }
    }

    this.showThisNode = function (n){
      let hasNode = document.querySelector(`#${n.idName}`)
      if(!hasNode)
        n.decorate(this.openDialog)
    }

    this.reloadProperties = () => {
      try {
          this.isInvisible();
          let index = this.node.buttonSelected();
          this.alterSelect(this.node, index)
      } catch (e) {
          throw `Classe ${this.nameClass}, Metodo reloadProperties().\n${e}`;
      }
    }
    this.update = function() {
        let d = this.node
    
        d3.selectAll(`#${d.idName} > .bt-selection`).remove()
        d3.select(`#${d.idName} > .btProductionChange`).text(d.title)
        d.buttons.forEach((b, i) => this.createButtons(d3.select(`#${d.idName}`), b, i))
      }
  }
}